var _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 22,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0065BD"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 22,
    height: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ED2939"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 2,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 22,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFo);
export default __webpack_public_path__ + "static/media/fo.27f92db9645246376f67caad47173677.svg";
export { ForwardRef as ReactComponent };